import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/tip-calculator',
  component: () => import('../../routes/TipCalculator.svelte'),
  card: {
    id: 'tip-calculator',
    title: 'Tip Calculator',
    description: 'Calculate the tip and split the bill evenly with custom tip percentages.',
    icon: 'restaurant',
    iconBgClass: 'bg-rose-50',
    iconTextClass: 'text-rose-600',
    href: '/tip-calculator',
    category: 'Life & Budget',
  },
  seo: {
    title: 'Tip Calculator – Free Tip & Bill Splitter Calculator',
    description: 'Free tip calculator with bill splitting. Calculate tip amounts for any percentage and split the bill evenly among any number of people. Includes quick comparison table for common tip percentages.',
  },
};

export default meta;
